import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useEffect, useState } from "react";
import Modal from "../../components/modal";
import Author from "components/author";
import { transferAccountCall } from "api/api";

const defaultState = {
  holder_name: "",
  address: "",
  phone_number: "",
  account_number: "",
  transferred_date: "",
};

export default function TransferAccountForm({ onClose, reload, account }) {
  const [state, setState] = useState(defaultState);
  const onUpdate = async () => {
    if (!state.holder_name) {
      return global.showAlert(
        "Validation Errors",
        "Holder Name is required to update an account",
        "warning"
      );
    }

    if (!state.transferred_date) {
      return global.showAlert(
        "Validation Errors",
        "Transferred Date is required to transfer an account",
        "warning"
      );
    }

    const { holder_name, address, phone_number, transferred_date } = state;
    const response = await transferAccountCall(account.id, {
      holder_name,
      address,
      phone_number,
      transferred_date,
    });
    if (response) {
      reload();
      onClose();
    }
  };

  useEffect(() => {
    if (account) {
      setState({
        ...defaultState,
        account_number: account.account_number,
      });
    }
  }, [account]);

  return (
    account && (
      <Modal
        open={open}
        title={"Transfer Account"}
        actions={
          <MDBox display="flex" gap={1} justifyContent="right">
            <MDButton onClick={onUpdate} variant="gradient" color="info">
              submit
            </MDButton>
            <MDButton onClick={onClose} variant="gradient" color="error">
              cancel
            </MDButton>
          </MDBox>
        }
      >
        <Author name={account.holder_name} address={account.address} />
        <div
          style={{ height: 1, background: "#d3d3d3", marginTop: "15px", marginBottom: "20px" }}
        />
        <MDBox component="form" role="form">
          <MDBox mb={2}>
            <MDInput
              type="string"
              label="Account No"
              fullWidth
              value={state.account_number}
              disabled
            />
          </MDBox>
          <MDBox mb={2}>
            <MDInput
              type="string"
              label="Holder Name"
              fullWidth
              value={state.holder_name}
              onChange={(event) => {
                setState({ ...state, holder_name: event.target.value });
              }}
            />
          </MDBox>
          <MDBox mb={2}>
            <MDInput
              type="string"
              label="Address"
              fullWidth
              value={state.address}
              onChange={(event) => {
                setState({ ...state, address: event.target.value });
              }}
            />
          </MDBox>
          <MDBox mb={2}>
            <MDInput
              type="string"
              label="Phone Number"
              fullWidth
              value={state.phone_number}
              onChange={(event) => {
                setState({ ...state, phone_number: event.target.value });
              }}
            />
          </MDBox>

          <MDBox mb={2}>
            <MDInput
              type="date"
              label="Transferred Date"
              fullWidth
              value={state.transferred_date}
              onChange={(event) => {
                setState({ ...state, transferred_date: event.target.value });
              }}
            />
          </MDBox>
        </MDBox>
      </Modal>
    )
  );
}
